import { GridSize } from '@atoms/GridSlider/GridSlider';
import ColourSwatchVariantEnum from '@models/enums/ColourSwatchVariantEnum';

export const gridConfig = {
  // 4 col
  100: {
    gridClasses:
      'md:tw-gap-x-md xl:tw-gap-x-5 tw-gap-x-xs tw-gap-y-lg md:tw-gap-y-xl xl:tw-gap-y-2xl xl:tw-gap-x-md',
    cardSize: 'tw-col-span-12 md:tw-col-span-6 xl:tw-col-span-3',
    cardVariant: ColourSwatchVariantEnum.Detailed,
    hotspotPosition:
      'xl:tw-col-span-6 xl:tw-row-span-1 xl:tw-col-start-0 xl:tw-row-start-2 tw-col-span-full tw-row-span-1 tw-col-start-0 tw-row-start-5 md:tw-row-start-3 -tw-mx-xs md:tw-mx-0',
    colourInspirationPosition:
      'xl:tw-col-span-3 xl:tw-row-span-1 xl:tw-col-start-0 xl:tw-row-start-4 tw-col-start-0 tw-row-start-8 tw-col-span-full tw-row-span-1 tw-min-h-[550px] md:tw-col-start-7 md:tw-row-start-5 md:tw-col-span-6 md:tw-row-span-1',
    productInspirationPosition:
      'xl:tw-col-span-3 xl:tw-row-span-1 xl:tw-col-start-4 xl:tw-row-start-3 tw-col-start-0 tw-row-start-8 tw-col-span-full tw-row-span-1 tw-min-h-[550px] md:tw-col-start-7 md:tw-row-start-5 md:tw-col-span-6 md:tw-row-span-1',
    hotspot: {
      occupiedSpaceCount: { sm: 1, md: 2, xl: 2 }, // amount of grid spaces the hotspot occupies
      minResultsToShow: { sm: 4, md: 4, xl: 6 }, // minimum amount of results to show before the card is displayed
      aspectRatio: { sm: 375 / 458, md: 688 / 550, xl: 640 / 620 },
    },
    inspiration: {
      occupiedSpaceCount: { sm: 1, md: 1, xl: 1 },
      minResultsToShow: { sm: 9, md: 11, xl: 10 },
    },
  },
  // 6 col
  50: {
    gridClasses:
      'md:tw-gap-x-md tw-gap-x-xs tw-gap-y-lg md:tw-gap-y-xl xl:tw-gap-y-2xl xl:tw-gap-x-5',
    cardSize: 'tw-col-span-6 md:tw-col-span-4 xl:tw-col-span-2',
    cardVariant: ColourSwatchVariantEnum.Default,
    hotspotPosition:
      'xl:tw-col-span-6 xl:tw-row-span-2 xl:tw-col-start-7 xl:tw-row-start-2 tw-col-span-full tw-row-span-1 tw-col-start-0 tw-row-start-3 tw-col-span-full tw-row-span-1 tw-col-start-0 tw-row-start-3 -tw-mx-xs md:tw-mx-0',
    colourInspirationPosition:
      'tw-col-span-full tw-col-start-0 tw-row-span-1 tw-row-start-7 tw-min-h-[550px] md:tw-col-span-8 md:tw-row-span-2 md:tw-col-start-0 md:tw-row-start-6 xl:tw-col-span-4 xl:tw-row-span-2 xl:tw-col-start-0 xl:tw-row-start-4',
    productInspirationPosition:
      'tw-col-span-full tw-col-start-0 tw-row-span-1 tw-row-start-7 tw-min-h-[550px] md:tw-col-span-8 md:tw-row-span-2 md:tw-col-start-0 md:tw-row-start-6 xl:tw-col-span-4 xl:tw-row-span-2 xl:tw-col-start-0 xl:tw-row-start-4',
    hotspot: {
      occupiedSpaceCount: { sm: 2, md: 3, xl: 6 },
      minResultsToShow: { sm: 5, md: 7, xl: 12 },
      aspectRatio: { sm: 375 / 458, md: 688 / 550, xl: 646 / 830 },
    },
    inspiration: {
      occupiedSpaceCount: { sm: 2, md: 4, xl: 4 },
      minResultsToShow: { sm: 11, md: 14, xl: 20 },
    },
  },
  // 12 col
  0: {
    gridClasses:
      'md:tw-gap-x-xs tw-gap-x-[7px] tw-gap-y-sm md:tw-gap-y-md xl:tw-gap-y-lg',
    cardSize: 'tw-col-span-3 md:tw-col-span-2 xl:tw-col-span-1',
    cardVariant: ColourSwatchVariantEnum.Simple,
    hotspotPosition:
      'xl:tw-col-span-6 xl:tw-row-span-4 xl:tw-col-start-7 xl:tw-row-start-3 tw-col-span-full tw-row-span-1 tw-col-start-0 tw-row-start-5 -tw-mx-xs md:tw-mx-0',
    colourInspirationPosition:
      'tw-col-span-full tw-col-start-0 tw-row-span-1 tw-row-start-8 tw-min-h-[550px] xl:tw-col-span-3 xl:tw-row-span-3 xl:tw-col-start-0 xl:tw-row-start-8 md:tw-col-span-6 md:tw-row-span-3 md:tw-col-start-0 md:tw-row-start-8',
    productInspirationPosition:
      'tw-col-span-full tw-col-start-0 tw-row-span-1 tw-row-start-8 tw-min-h-[550px] xl:tw-col-span-3 xl:tw-row-span-3 xl:tw-col-start-0 xl:tw-row-start-8 md:tw-col-span-6 md:tw-row-span-3 md:tw-col-start-0 md:tw-row-start-8',
    hotspot: {
      occupiedSpaceCount: { sm: 4, md: 6, xl: 24 },
      minResultsToShow: { sm: 17, md: 25, xl: 48 },
      aspectRatio: { sm: 375 / 458, md: 688 / 550, xl: 648 / 792 },
    },
    inspiration: {
      occupiedSpaceCount: { sm: 4, md: 9, xl: 9 },
      minResultsToShow: { sm: 25, md: 45, xl: 87 },
    },
  },
};

export const getGridConfig = (gridSize: GridSize) => gridConfig[gridSize];

// A bit ugly but there are different scenarios we need to check to clean the data, can look at improving this later
export function sanitizeQuery<T extends Record<string, any>>(query: T): T {
  return Object.fromEntries(
    Object.entries(query).filter(
      ([, value]) =>
        value !== undefined &&
        value !== 'undefined' &&
        value !== '' &&
        value !== 'false' &&
        value !== false &&
        !(Array.isArray(value) && value.length === 0),
    ),
  ) as T;
}
